export const apiUrls = {
  //Auth
  login: "Auth/login",
  ResetPassword: "Auth/ResetPassword",
  ProfileUpdate: "Auth/ProfileUpdate",
  ProfileDetails: "Auth/ProfileDetails",
  HomePageContent: "Auth/HomePageContent",
  SettingById: "Common/SettingById",
  GetPaymentMethod:"Common/GetPaymentMethod",
  UpdateSettingById: "Common/UpdateSettingById",
  ForgetPassword: "Auth/ForgetPassword",
  VerifyForgetPassword: "Auth/VerifyForgetPassword",
  GetCompanyCodesByEmail: "Auth/GetCompanyCodesByEmail",
  GetAllJobs: "Common/GetAllJobs",
  GetAllDiscount: "Common/GetAllDiscount",
  GetAllFinance:"Common/GetAllFinance",
  GetInvoiceHtml:"Common/GetInvoiceHtml",
  OrderGeneration:"Stripe/OrderGeneration",
  //Comman Api
  permissionlist: "Module/modules",
  uploadFiles: "Common/FileUpload",
  GetAllJobTitle: "Common/GetAllJobTitle",
  GetAllVendor: "Common/GetAllVendor",
  GetAllStages:"Common/GetAllStages",
  GetallStagesMapping:"Common/GetallStagesMapping",
  GetAllMeterial: "Common/GetAllMaterial",
  GetAllProductType: "Common/GetAllProductType",
  GetAllProduct: "Common/GetAllProduct",
  GetAllGHL_Users:"Common/GetAllGHL_Users",
  GetAllOption: "Common/GetAllOption",
  GetAllComponent: "Common/GetAllComponent",
  GetAllUnitOfMeasurement: "Common/GetAllUnitOfMeasurement",
  GetAllAddress: "Common/GetAllAddress",
  GetAllRoles: "Common/GetAllRoles",
  GetAllTemplateCategory:"Common/GetAllTemplateCategory",
  GetAllJobType: "Common/GetAllJobType",
  GetAllAssignedPerson: "Common/GetAllAssignedPerson",
  GetAllJobStatus: "Common/GetAllJobStatus",
  GetAllRegion: "Common/GetAllRegion",
  GetAllContact: "Common/GetAllContacts",
  GetAllContactsList:"Common/GetAllContactsList",
  GetEmailTypeConfiguration:"Configuration/GetEmailTypeConfiguration",
  ImportandExport: "ImportandExport/import",
  ExportContacts: "ImportandExport/ExportAll",
  DashBoard: "Common/DashBoard",
  GetAllJobDetails:"Common/GetAllJobDetails",
  GetAllExpression: "Common/GetAllExpression",
  GetAllState:"Common/GetAllState",
  GetAllTaxAuthority:"Common/GetAllTaxAuthority",
  GetAllBank:"Common/GetAllBank",
  GetAllExpressionChip:"Common/GetAllExpressionChip",
  GetAllInvoice:"Common/GetAllInvoice",
  GetAllIMaterial:"Common/GetAllmaterialList",
  GetAllJobList:"Common/GetAllJobs",
  GetAllMstContactType:"Common/GetAllMstContactType",
  GetAllTax:"Common/GetAllTax",
  GetAllTaxGroup:"Common/GetAllTaxGroup",
  EstimationUniquename:"Common/EstimationUniquename",
  OrderUniquename:"Common/OrderUniquename",
  GetAllTenantAnd_Users:"Common/GetAllTenantAnd_Users",
  BuildEstimateAfterDiscount:"Estimate/BuildEstimateAfterDiscount",
  ContactBreakdown:"Common/ContactBreakdown",
  ContactUniqueIdBreakdown:"Common/ContactUniqueIdBreakdown",
  ContactJobBreakdown:"Common/ContactJobBreakdown",
  ContactEstimatioBreakdown:"Common/ContactEstimatioBreakdown",
  ContactEstimationProductBreakdown:"Common/ContactEstimationProductBreakdown",
  GetProductBreakdown:"Common/GetProductBreakdown",
  GetAllEstimate:"Common/GetAllEstimate",
  GeltallLocation:"Common/GeltallLocation",
  GetAll_Placeholder:"Common/GetAll_Placeholder",
  Get_PlaceholderByCategoryId:"Common/Get_PlaceholderByCategoryId",
  CreateLocation:"Common/CreateLocation",
  GetAllEstimateContact:"Common/GetAllEstimateContact",
  GetAllNotification:"Common/GetAllNotification",
  ghlsync:"common/ghlsync",
  UserSync:"Common/UserSync",
  EstimateAmmount:"Common/EstimateAmmount",
  GenerateToken:"Common/GenerateToken",
  GetAccessToken:"Common/GetAccessToken",
  GoHighLevelAuthorization:"Common/GoHighLevelAuthorization",
  SyncCustomField:"Common/Sync-Custom-Field",
  DeleteConfiguration:"Configuration/DeleteConfiguration",
  EmailOAuth:"EmailOAuth/LoginOauth",
  GenerateCode:"Common/GenerateCode",
  GetAllManagePartnerProduct:"ManagePartnersProducts/GetAllManagePartnerProduct",
  ManagePartnersProductsGetMSRP:"ManagePartnersProducts/GetMSRP",
  SyncContactandJobforPartner:"Configuration/SyncContactandJobforPartner",
  UpdateEstimateLive:"Estimate/UpdateEstimateLive",
  GetAllPartnersInvoices:"Common/GetAllPartnersInvoices",
MapEstimateOpportinuityURL:"Configuration/MapEstimateOpportinuityURL",
  //MstTemplate
  MstTemplate:"MstTemplate/GetAll",
MstTemplateCreate:"MstTemplate/Create",
MstTemplateUpdate:"MstTemplate/Update",
MstTemplateActiveInActive:"MstTemplate/ActiveInActive",
MstTemplateDelete:"MstTemplate/Delete",
  //Tanent
  Tenantlist: "Tenant/GetAll",
  TenantCreate: "Tenant/Create",
  TenantUpdate: "Tenant/Update",
  TenantDelete: "Tenant/Delete",
  TenantActiveInActive: "Tenant/ActiveInActive",
  GetTenantsListByUsername: "Tenant/GetTenantsListByUsername",
  GetUserDataForTenantSwitch: "Tenant/GetUserDataForTenantSwitch",
  //Sub Tanent
  SubTenant: "SubTenant/GetAll",
  SubTenantCreate: "SubTenant/Create",
  SubTenantUpdate: "SubTenant/Update",
  SubTenantDelete: "SubTenant/Delete",
  SubTenantActiveInActive: "SubTenant/ActiveInActive",
  //Roles
  Role: "Roles/GetAll",
  RoleCreate: "Roles/Create",
  RoleUpdate: "Roles/Update",
  RoleDelete: "Roles/Delete",
  RoleActiveInActive: "Roles/ActiveInActive",
  //Users
  User: "User/GetAll",
  UserCreate: "User/Create",
  UserUpdate: "User/Update",
  UserDelete: "User/Delete",
  UserActiveInActive: "User/ActiveInActive",
  //contract
  Contact: "Contact/GetAll",
  ContactCreate: "Contact/Create",
  ContactUpdate: "Contact/Update",
  ContactDelete: "Contact/Delete",
  ContactActiveInActive: "Contact/ActiveInActive",
  GetAllArchiveContacts:"Contact/GetAllArchiveContacts",
  ArchiveContacts:"Contact/ArchiveContacts",
  //Material
  Material: "Material/GetAll",
  MaterialCreate: "Material/Create",
  MaterialUpdate: "Material/Update",
  MaterialDelete: "Material/Delete",
  MaterialActiveInActive: "Material/ActiveInActive",
  DownloadSample:"ImportandExport/DownloadSample",
//SubtenantProductMarkup
  SubtenantProductMarkup:"SubtenantProductMarkup/GetAll",
  SubtenantProductMarkupCreate: "SubtenantProductMarkup/Create",
  SubtenantProductMarkupUpdate: "SubtenantProductMarkup/Update",
  SubtenantProductMarkupDelete: "SubtenantProductMarkup/Delete",
  SubtenantProductMarkupActiveInActive: "SubtenantProductMarkup/ActiveInActive",
  //Component
  Component: "Component/GetAll",
  ComponentCreate: "Component/Create",
  ComponentUpdate: "Component/Update",
  ComponentDelete: "Component/Delete",
  ComponentActiveInActive: "Component/ActiveInActive",
  AddComponentMaterial: "Component/AddComponentMaterial",
  DeleteComponentMaterial: "Component/DeleteComponentMaterial",
  UpdateComponentMaterial: "Component/UpdateComponentMaterial",
  //Address
  Address: "Address/GetAll",
  AddressCreate: "Address/Create",
  AddressUpdate: "Address/Update",
  AddressDelete: "Address/Delete",
  AddressActiveInActive: "Address/ActiveInActive",
  //Vendor
  Vendor: "Vendor/GetAll",
  VendorCreate: "Vendor/Create",
  VendorUpdate: "Vendor/Update",
  VendorDelete: "Vendor/Delete",
  VendorActiveInActive: "Vendor/ActiveInActive",
//GetGHLConfiguration
  GetGHLConfiguration:"Configuration/GetGHLConfiguration",
  AddGHLConfiguration:"Configuration/AddGHLConfiguration",
  GetStripeConfiguration:"Configuration/GetStripeConfiguration",
  GetEmailConfiguration:"Configuration/GetEmailConfiguration",
  AddStripeConfiguration:"Configuration/AddStripeConfiguration",
  AddOrUpdateEmailConfiguration:"Configuration/AddOrUpdateEmailConfiguration",
  UpdateGHlConfigforPartner:"Configuration/UpdateGHlConfigforPartner",
  GHLStagesMapping:"Common/GHLStagesMapping",
  EmailOAuth2:"EmailOAuth/Callback",
  GetGhlConfigforPartner:"Configuration/GetGhlConfigforPartner",
    //ProductType
    ProductType: "ProductType/GetAll",
    ProductTypeCreate: "ProductType/Create",
    ProductTypeUpdate: "ProductType/Update",
    ProductTypeDelete: "ProductType/Delete",
    ProductTypeActiveInActive: "ProductType/ActiveInActive",
     //JobType
     JobType: "JobType/GetAll",
     JobTypeCreate: "JobType/Create",
     JobTypeUpdate: "JobType/Update",
     JobTypeDelete: "JobType/Delete",
     JobTypeActiveInActive: "JobType/ActiveInActive",

      JobTitle: "JobTitle/GetAll",
     JobTitleCreate: "JobTitle/Create",
     JobTitleUpdate: "JobTitle/Update",
     JobTitleDelete: "JobTitle/Delete",
     JobTitleActiveInActive: "JobTitle/ActiveInActive",

      PlaceHolder: "PlaceHolder/GetAll_Placeholder",
     PlaceHolderCreate: "PlaceHolder/Add_Placeholder",
    PlaceHolderUpdate: "PlaceHolder/Edit_Placeholder",
     PlaceHolderDelete: "PlaceHolder/Delete_Placeholder",
     PlaceHolderActiveInActive: "PlaceHolder/ActiveInActive",


       PlaceholderMapping: "PlaceholderMapping/GetAll",
  PlaceholderMappingCreate: "PlaceholderMapping/Create",
  PlaceholderMappingUpdate: "PlaceholderMapping/Update",
     PlaceholderMappingDelete: "PlaceholderMapping/Delete",
     PlaceholderMappingActiveInActive: "PlaceholderMapping/ActiveInActive",

    TemplateCategory:"TemplateCategory/GetAll",
    TemplateCategoryActiveInActive:"TemplateCategory/ActiveInActive",
    TemplateCategoryCreate:"TemplateCategory/Create",
    TemplateCategoryUpdate:"TemplateCategory/Update",
TemplateCategoryDelete:"TemplateCategory/Delete",
NotificationTemplate:"NotificationTemplate/GetAll",
 NotificationTemplateCreate:"NotificationTemplate/Create",
    NotificationTemplateUpdate:"NotificationTemplate/Update",
      NotificationTemplateActiveInActive:"NotificationTemplate/ActiveInActive",
     NotificationTemplateDelete:"NotificationTemplate/Delete",
  //Report
  GetInvoiceReport:"Report/GetInvoiceReport",
  GetOrderConfirmed:"Report/GetOrderConfirmed",
  GetTaxReport:"Report/GetTaxReport",
  //Options
  Option: "Option/GetAll",
  OptionCreate: "Option/Create",
  OptionUpdate: "Option/Update",
  OptionDelete: "Option/Delete",
  OptionActiveInActive: "Option/ActiveInActive",
  //Product
  Product: "Product/GetAll",
  ProductCreate: "Product/Create",
  ProductUpdate: "Product/Update",
  ProductDelete: "Product/Delete",
  ProductActiveInActive: "Product/ActiveInActive",
  DeleteProductComponent: "Product/DeleteProductComponent",
  AddProductComponent: "Product/AddProductComponent",
  UpdateProductComponent: "Product/UpdateProductComponent",
  ManagePartnersProducts:"ManagePartnersProducts/Create",
  //Job
  Job: "Job/GetAll",
  JobCreate: "Job/Create",
  JobUpdate: "Job/Update",
  JobDelete: "Job/Delete",
  UpdateJobStatus:"Job/UpdateJobStatus",
  CreateAppointment:"Job/CreateAppointment",
  GetAppointment:"Job/GetAppointment",
  UpdateJobPowderCoatColor: `Job/UpdateJobPowderCoatColor`,
  //taxes
  Tax: "Tax/GetAll",
  TaxCreate: "Tax/Create",
  TaxUpdate: "Tax/Update",
  TaxDelete: "Tax/Delete",
  TaxActiveInActive: "Tax/ActiveInActive",
  //window
  Window: "Window/GetAll",
  WindowCreate: "Window/Create",
  WindowUpdate: "Window/Update",
  WindowDelete: "Window/Delete",
  WindowActiveInActive: "Window/ActiveInActive",
  //Estimate/GetAll
  Estimate: "Estimate/GetAll",
  EstimateCreate: "Estimate/Create",
  EstimateUpdate: "Estimate/Update",
  EstimateDelete: "Estimate/Delete",
  EstimateActiveInActive: "Estimate/ActiveInActive",
  SendForApproval: "Estimate/SendForApproval",
  ViewEstimate: "Estimate/ViewEstimate",
  EstimateApproved: "Estimate/EstimateApproved",
  RequestNewEstimate:"Estimate/RequestNewEstimate",
  EstimationBreakdown:"Estimate/EstimationBreakdown",
  BuildEstimate:"Estimate/BuildEstimate",
  BuildEstimate_v2:"Estimate/BuildEstimate",
  SendInvoice:"Invoice/SendInvoice",
  DownloadPDForSendMail:"Order/DownloadOrderPdf",
  SendOrder:"Order/SendOrder",
  ChangeOrderStatus:"Order/ChangeOrderStatus",
  SendEstimateOrDownload:"Estimate/SendEstimate",
  EstimatePdfDownload:"Estimate/EstimatePdfDownload",
  DownloadInvoice:"Invoice/DownloadInvoice",
  ApplyPaymentFees:"Estimate/ApplyPaymentFees",
  //discount
  Discount: "Discount/GetAll",
  DiscountCreate: "Discount/Create",
  DiscountUpdate: "Discount/Update",
  DiscountDelete: "Discount/Delete",
  DiscountActiveInActive: "Discount/ActiveInActive",
  //expression
  Expression: "Expression/GetAll",
  ExpressionCreate: "Expression/Create",
  ExpressionUpdate: "Expression/Update",
  ExpressionDelete: "Expression/Delete",
  ExpressionActiveInActive: "Expression/ActiveInActive",
  ExpressionValidate:"Estimate/Validate",
  //Order
  OrderCreate: "Order/Create",
   GenerateOrder: "Order/GenerateOrder",
  Order:"Order/GetAll",
  orderSendForApproval:"Order/SendForApproval",
  UpdateNotification:"Common/UpdateNotification",
   ReadAllNotification:"Common/ReadAllNotification",
  OrderUpdate:"Order/Update",
  ViewOrder:"Order/ViewEstimate",
  OrderApproved:"Order/OrderApproved",
  ViewHistory:"Order/ViewHistory",
  GenerateOrderSheet:"Order/GenerateOrderSheet",
  ViewEstimateHistory:"Estimate/ViewEstimateHistory",
  UpdateOrderLive:"Order/UpdateOrderLive",
  OrderDelete:"Order/Delete",
  //Invoice
  Invoice:"Invoice/GetAll",
  InvoiceCreate:"Invoice/Create",
  InvoiceUpdate:"Invoice/Update",
  InvoiceDelete:"Invoice/Delete",
  InvoiceActiveInActive:"Invoice/ActiveInActive",
  GetPaymentDetails:"Stripe/GetPaymentDetails",
  GeneratePaymentLink:"Invoice/GeneratePaymentLink",
  //Payment
  Payment:"Payment/GetAll",
  PaymentCreate:"Payment/Create",
  PaymentUpdate:"Payment/Update",
  PaymentDelete:"Payment/Delete",
  PaymentActiveInActive:"Payment/ActiveInActive",
  //vendor Order
  VendorOrder:"VendorOrder/GetAll",
  VendorOrderCreate:"VendorOrder/Create",
  VendorOrderUpdate:"VendorOrder/Update",
  VendorOrderDelete:"VendorOrder/Delete",
  VendorOrderActiveInActive:"VendorOrder/ActiveInActive",
  updateVendorOrderItem:"VendorOrder/update_VendorOrderItem",
  deleteVendorOrderItem:"VendorOrder/delete_VendorOrderItem",
  VendorOrderInvoice:"VendorOrder/VendorOrderInvoice",
  //job schedule
  JobSchedule:"JobSchedule/GetAll",
  JobScheduleCreate:"JobSchedule/Create",
  JobScheduleUpdate:"JobSchedule/Update",
  JobScheduleDelete:"JobSchedule/Delete",
  JobScheduleActiveInActive:"JobSchedule/ActiveInActive",
  
  //contact
  JobContact:"JobContact/GetAll",
  JobContactCreate:"JobContact/Add",
  JobContactUpdate:"JobContact/Edit",
  JobContactDelete:"JobContact/Delete",
  JobContactActiveInActive:"JobContact/ActiveInActive",

  ///Upload Document in job APIs
  UploadDocument:"UploadDocument/Create",
  UploadDocumentGetAll:"UploadDocument/GetAll",
  UploadDocumentUpdate:"UploadDocument/Update",
  UploadDocumentDelete:"UploadDocument/Delete",
  UploadDocumentDownloadBlobAsBase64:"UploadDocument/DownloadBlobAsBase64",
  
  // Powder Coat Color APIs
  GetPowderCoatColorsForDropdown: `PowderCoatColor/GetAllForDropdown`,
  GetAllPowderCoatColor: `PowderCoatColor/GetAll`,
  PowderCoatColorCreate: `PowderCoatColor/Create`,
  PowderCoatColorUpdate: `PowderCoatColor/Update`,
  PowderCoatColorDelete: `PowderCoatColor/Delete`,
  PowderCoatColorActiveInActive: `PowderCoatColor/ActiveInActive`,

  //Impersonate Tenant
  ImpersonateTenant:"Auth/ImpersonateTenant",

    //Vendor
  TaxAuthority: "TaxAuthority/GetAll",
  TaxAuthorityCreate: "TaxAuthority/Create",
  TaxAuthorityUpdate: "TaxAuthority/Update",
  TaxAuthorityDelete: "TaxAuthority/Delete",
  TaxAuthorityActiveInActive: "TaxAuthority/ActiveInActive",
  //Tax
    TaxNew: "Tax/GetAll",
    TaxNewActiveInActive: "Tax/ActiveInActiveTax",
    TaxNewDelete: "Tax/Delete",
    TaxnewCreate: "Tax/Create",
  TaxnewUpdate: "Tax/Update",
  CommonGetAllTaxs:"Common/GetAllTaxs",
  //Tax Group
  TaxGroup: "TaxGroup/GetAll",
    TaxGroupCreate: "TaxGroup/Create",
    TaxGroupUpdate: "TaxGroup/Update",
 TaxGroupActiveInActive: "TaxGroup/ActiveInActive",
  TaxGroupDelete: "TaxGroup/Delete",
//BankDetails
  BankDetails: "BankDetails/GetAll",
BankDetailsCreate: "BankDetails/Create",
BankDetailsUpdate: "BankDetails/Update",
BankDetailsActiveInActive: "BankDetails/ActiveInActive",
BankDetailsDelete: "BankDetails/Delete",
//Finance
  Finance: "Finance/GetAll",
FinanceCreate: "Finance/Create",
FinancesUpdate: "Finance/Update",
FinanceActiveInActive: "Finance/ActiveInActive",
FinanceDelete: "Finance/Delete",

};
